import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

/* ---------------- Header Component ---------------- */
// const Header = ({ user, onSignOut, currentPage = "pricing" }) => {
//   const navigate = useNavigate();
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//   const getNavLinkStyle = (page) => ({
//     fontSize: "16px",
//     margin: "0 12px",
//     color: "#9333ea",
//     textTransform: "capitalize",
//     background: "none",
//     border: "none",
//     cursor: "pointer",
//     borderBottom: currentPage === page ? "2px solid #a855f7" : "none",
//   });

//   const getMobileNavLinkStyle = (page) => ({
//     color: currentPage === page ? "#fff" : "#cfcfcf",
//     fontSize: "18px",
//     background: "none",
//     border: "none",
//     cursor: "pointer",
//     textAlign: "left",
//     fontWeight: currentPage === page ? "bold" : "normal",
//   });

//   return (
//     <header
//       style={{
//         position: "sticky",
//         top: 0,
//         zIndex: 1000,
//         backgroundColor: "white",
//         padding: "15px 20px",
//       }}
//     >
//       <div
//         style={{
//           width: "100%",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         {/* Left: Logo + Desktop Nav */}
//         <div style={{ display: "flex", alignItems: "center" }}>
//           <button
//             onClick={() => navigate("/")}
//             style={{
//               fontSize: "22px",
//               fontWeight: "bold",
//               color: "#9333ea",
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             Aisle Agent
//           </button>
//           <nav
//             style={{
//               display: window.innerWidth > 768 ? "flex" : "none",
//               marginLeft: "20px",
//             }}
//           >
//             {["home", "categories", "pricing", "about", "contact"].map(
//               (page) => (
//                 <button
//                   key={page}
//                   onClick={() => navigate(`/${page === "home" ? "" : page}`)}
//                   style={getNavLinkStyle(page)}
//                 >
//                   {page.charAt(0).toUpperCase() + page.slice(1)}
//                 </button>
//               )
//             )}
//           </nav>
//         </div>

//         {/* Right: Auth + Mobile Menu Button */}
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           {user ? (
//             <button
//               onClick={onSignOut}
//               style={{
//                 background: "linear-gradient(135deg, #9333ea, #a855f7)",
//                 padding: "10px 20px",
//                 borderRadius: "8px",
//                 fontWeight: "600",
//                 color: "#fff",
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               Sign Out
//             </button>
//           ) : (
//             <button
//               onClick={() => navigate("/prelogin")}
//               style={{
//                 background: "linear-gradient(135deg, #9333ea, #a855f7)",
//                 padding: "10px 20px",
//                 borderRadius: "8px",
//                 fontWeight: "600",
//                 color: "#fff",
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               Browse Agents
//             </button>
//           )}
//           <button
//             onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//             style={{
//               display: window.innerWidth <= 768 ? "inline-block" : "none",
//               fontSize: "24px",
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               color: "#9333ea",
//             }}
//           >
//             {isMobileMenuOpen ? "✖" : "☰"}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {isMobileMenuOpen && (
//         <div
//           style={{
//             marginTop: "10px",
//             background: "rgba(20,20,40,0.95)",
//             borderRadius: "12px",
//             padding: "20px",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//             <input
//               type="text"
//               placeholder="Search agents..."
//               style={{
//                 width: "80%",
//                 padding: "5px",
//                 borderRadius: "6px",
//                 border: "none",
//               }}
//             />
//             <span>🔍</span>
//           </div>
//           <nav
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "10px",
//               marginTop: "15px",
//             }}
//           >
//             {["home", "categories", "pricing", "about", "contact"].map(
//               (page) => (
//                 <button
//                   key={page}
//                   onClick={() => {
//                     navigate(`/${page === "home" ? "" : page}`);
//                     setIsMobileMenuOpen(false);
//                   }}
//                   style={getMobileNavLinkStyle(page)}
//                 >
//                   {page.charAt(0).toUpperCase() + page.slice(1)}
//                 </button>
//               )
//             )}
//           </nav>
//         </div>
//       )}
//     </header>
//   );
// };

/* ---------------- Footer Component ---------------- */
// const Footer = () => (
//   <footer
//     style={{
//       width: "100%",
//       backgroundColor: "#1a1a2e",
//       color: "#fff",
//       textAlign: "center",
//       padding: "20px 0",
//       marginTop: "auto",
//     }}
//   >
//     <div
//       style={{
//         maxWidth: "1200px",
//         margin: "0 auto",
//         padding: "0 225px",
//       }}
//     >
//       <p style={{ margin: 0, fontSize: "14px" }}>
//         Powered By{" "}
//         <span style={{ fontWeight: "bold", color: "#8b5cf6" }}>
//           SLT Digital Lab
//         </span>{" "}
//         | @2025
//       </p>
//     </div>
//   </footer>
// );

/* ---------------- Landing Page Pricing ---------------- */
function LandingPagePricing() {
  const navigate = useNavigate();
  const [isAnnual, setIsAnnual] = useState(false);

  const plans = [
    {
      name: "Free",
      description: "Perfect for getting started with AI agents",
      price: { monthly: 0, annual: 0 },
      popular: false,
      features: [
        "Access to free agents",
        "Basic support",
        "Community forums",
        "Up to 5 agent installations",
        "Standard documentation",
      ],
      limitations: [
        "No premium agents",
        "Limited support",
        "No priority updates",
      ],
      buttonText: "Get Started",
      buttonStyle: "free",
    },
    {
      name: "Pro",
      description: "For professionals and growing teams",
      price: { monthly: 29, annual: 290 },
      popular: true,
      features: [
        "Access to all agents",
        "Priority support",
        "Advanced analytics",
        "Unlimited installations",
        "Custom integrations",
        "Team collaboration",
        "API access",
        "Premium documentation",
      ],
      limitations: [],
      buttonText: "Start Pro Trial",
      buttonStyle: "pro",
    },
    {
      name: "Enterprise",
      description: "For large organizations with custom needs",
      price: { monthly: 99, annual: 990 },
      popular: false,
      features: [
        "Everything in Pro",
        "Dedicated account manager",
        "Custom agent development",
        "On-premise deployment",
        "Advanced security",
        "SLA guarantee",
        "Training & onboarding",
        "White-label options",
      ],
      buttonText: "Contact Sales",
      buttonStyle: "enterprise",
      limitations: [],
    },
  ];

  const faqs = [
    {
      question: "What happens when I exceed my plan limits?",
      answer:
        "We'll notify you when you're approaching your limits. You can upgrade your plan at any time or purchase additional capacity as needed.",
    },
    {
      question: "Can I change my plan at any time?",
      answer:
        "Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately, and we'll prorate any billing adjustments.",
    },
    {
      question: "Do you offer refunds?",
      answer:
        "We offer a 30-day money-back guarantee for all paid plans. If you're not satisfied, contact our support team for a full refund.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We accept all major credit cards, PayPal, and bank transfers for Enterprise customers. All payments are processed securely.",
    },
    {
      question: "Is there a free trial for paid plans?",
      answer:
        "Yes, we offer a 14-day free trial for Pro and Enterprise plans. No credit card required to start your trial.",
    },
  ];

  return (
    <div style={{ width: "100vw", minHeight: "100vh" }}>
      <div
        style={{
          // background: "linear-gradient(135deg, #1e003d, #34006f)",
          minHeight: "100vh",
          width: "100%",
          fontFamily: "Arial, sans-serif",
          color: "#fff",
        }}
      >
        <style>{`
          section {
            padding: 5rem 1rem;
            text-align: center;
            background: transparent;
          }
          h1 { font-size: 3rem; font-weight: bold; margin-bottom: 1.5rem; color: white; }
          h1 span { background: linear-gradient(to right, #2563eb, #9333ea); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
          h2 { font-size: 2rem; font-weight: bold; margin-bottom: 1rem; color: white; }
          p { font-size: 1.125rem; color: white; max-width: 750px; margin: 0 auto 1.5rem; line-height: 1.6; }
          .toggle-container { display: flex; align-items: center; justify-content: center; gap: 1rem; margin-bottom: 3rem; }
          .toggle-button { position: relative; width: 44px; height: 24px; border-radius: 9999px; cursor: pointer; background: #374151; transition: background 0.3s; }
          .toggle-button.active { background: #2563eb; }
          .toggle-thumb { position: absolute; top: 2px; left: 2px; width: 20px; height: 20px; border-radius: 50%; background: #fff; transition: transform 0.3s; }
          .toggle-thumb.active { transform: translateX(20px); }
          .pricing-cards { display: grid; gap: 2rem; }
          @media(min-width:768px) { .pricing-cards { grid-template-columns: repeat(3, 1fr); } }
          .card { background: transparent; border-radius: 1rem; border: 2px solid rgba(255,255,255,0.2); padding: 2rem; text-align: center; }
          .card.popular { border-color: #2563eb; transform: scale(1.05); }
          .popular-badge { background: linear-gradient(to right, #2563eb, #9333ea); color: white; padding: 0.25rem 0.75rem; border-radius: 9999px; font-size: 0.75rem; font-weight: 500; margin-bottom: 1rem; display: inline-block; }
          .card h3 { font-size: 1.5rem; font-weight: bold; margin-bottom: 0.5rem; }
          .price { font-size: 2.5rem; font-weight: bold; margin-bottom: 1rem; }
          .card button.free, .card button.enterprise { border: 2px solid #d1d5db; background: none; color: white; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer; }
          .card button.pro { background: #9333ea; color: white; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer; }
          .faq-item { border: 1px solid rgba(255,255,255,0.2); border-radius: 1rem; padding: 1.5rem; text-align: left; margin-bottom: 1rem; }
          footer { text-align: center; padding: 20px; margin-top: 40px; }
        `}</style>

        {/* Header */}
        {/* <Header currentPage="pricing" /> */}
        <Navbar/>

        {/* Hero */}
        <section className="hero">
          <h1>
            Smart <span>Flexible Plans</span>
          </h1>
          <p>
            Choose the perfect plan for your needs. Start free and scale as you
            grow. All plans include access to our marketplace and community
            support.
          </p>
          <div className="toggle-container">
            <span>{!isAnnual ? "Monthly" : "Monthly"}</span>
            <div
              className={`toggle-button ${isAnnual ? "active" : ""}`}
              onClick={() => setIsAnnual(!isAnnual)}
            >
              <div className={`toggle-thumb ${isAnnual ? "active" : ""}`} />
            </div>
            <span>{isAnnual ? "Annual" : "Annual"}</span>
            {isAnnual && <span className="save-badge">Save 17%</span>}
          </div>
        </section>

        {/* Pricing Cards */}
        <section className="pricing">
          <div className="pricing-cards">
            {plans.map((plan) => (
              <div
                key={plan.name}
                className={`card ${plan.popular ? "popular" : ""}`}
              >
                {plan.popular && (
                  <div className="popular-badge">Most Popular</div>
                )}
                <h3>{plan.name}</h3>
                <p>{plan.description}</p>
                <div className="price">
                  ${isAnnual ? plan.price.annual : plan.price.monthly}
                  {plan.price.monthly > 0 && (
                    <span>/{isAnnual ? "year" : "month"}</span>
                  )}
                </div>
                <button className={plan.buttonStyle}>{plan.buttonText}</button>
                <ul className="features-list">
                  {plan.features.map((f) => (
                    <li key={f}>✔ {f}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section className="faq">
          {faqs.map((faq, i) => (
            <div key={i} className="faq-item">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </section>

        {/* Footer */}
        
          <Footer/>
        
      </div>
    </div>
  );
}

export default LandingPagePricing;
